// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"o4-z","dimensionLabel":"p4-z","styleChooserControlWrapper":"q4-z","styleChooserControl":"r4-z","disabled":"s4-z","giftCard":"t4-z","styleChooserText":"u4-z"};